import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=2b8b4162&scoped=true&"
import script from "./Ratings.vue?vue&type=script&setup=true&lang=js&"
export * from "./Ratings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b4162",
  null
  
)

export default component.exports